import React, { FC, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Grid, TextField, Box, Switch, FormControlLabel } from "@mui/material";
import { SCUIButton } from "../../../atomic/atoms";
import Swal from "sweetalert2";
import { CookieManagementCommand } from "../../../services/command";
import { useTranslation } from "react-i18next";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import { CKM, ckmCls } from "../cookieManagement.classes";

interface IProps {
  selectedRow?: any;
  onCloseMenu?: any;
  onUpdate?: any;
  cookieType?: any;
}

export const SCUICookieManagementDrawerContent: FC<IProps> = ({
  selectedRow,
  onCloseMenu,
  onUpdate,
  cookieType,
}) => {
  const { t } = useTranslation();
  const [cookieTypes, setCookieTypes] = React.useState(
    selectedRow ? selectedRow.cookieType : 0
  );
  const [cookieName, setCookieName] = React.useState(
    selectedRow ? selectedRow.cookieName : ""
  );
  const [usegeTime, setUsageTime] = React.useState(
    selectedRow ? selectedRow.usageTime : ""
  );
  const [usagePurpose, setUsagePurpose] = React.useState(
    selectedRow ? selectedRow.usagePurpose : ""
  );
  const [siteName, setSiteName] = React.useState(
    selectedRow ? selectedRow.siteName : ""
  );
  const [ios, setIos] = React.useState(selectedRow ? selectedRow.ios : false);
  const [android, setAndroid] = React.useState(
    selectedRow ? selectedRow.android : false
  );
  const [selectedStatus, setSelectedStatus] = useState<any>(
    selectedRow ? selectedRow.status : false
  );

  const statusItems = [
    { label: "Aktif", value: true },
    { label: "Pasif", value: false },
  ];

  const handleSelectChangeIsActive = (event: any) => {
    setSelectedStatus(event.target.value);
  };

  const handleChangeCookieName = (event: any) => {
    setCookieName(event.target.value);
  };
  const handleChangeUsageTime = (event: any) => {
    setUsageTime(event.target.value);
  };
  const handleSelectChangeCookieType = (event: any) => {
    setCookieTypes(event.target.value);
  };
  const handleChangeUsagePurpage = (event: any) => {
    setUsagePurpose(event.target.value);
  };
  const handleChangeSiteName = (event: any) => {
    setSiteName(event.target.value);
  };
  const handleIosChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIos(event.target.checked);
  };

  const handleAndroidChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAndroid(event.target.checked);
  };
  const UpdateCookie = () => {
    Swal.fire({
      text: "Güncellemek istediğinizden emin misiniz",
      cancelButtonText: t("general.cancel"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("general.update"),
    }).then((result: any) => {
      if (result.isConfirmed) {
        let params: any = {};
        params.cookieID = selectedRow.id;
        params.cookieName = cookieName;
        params.usageTime = usegeTime;
        params.usagePurpose = usagePurpose;
        params.siteName = siteName;
        params.cookieType = cookieTypes;
        params.ios = ios;
        params.android = android;
        params.status = selectedStatus;
        const isValid =
          cookieName &&
          cookieName?.trim().length > 0 &&
          siteName &&
          siteName?.trim().length > 0 &&
          usegeTime &&
          usegeTime?.trim().length > 0 &&
          usagePurpose &&
          usagePurpose?.trim().length > 0;

        if (isValid) {
          CookieManagementCommand.UpdateCookie(params)
            .then((_res: any) => {
              onUpdate();
              Swal.fire(t("general.updated"), " ", "success");
              onUpdate();
              onCloseMenu();
            })
            .catch((error: any) => {
              console.log("Hata :>> ", error);
            })
            .finally(() => {});
        } else {
          Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
        }
      }
    });
  };
  const CreateCookie = async () => {
    let params: any = {};
    params.cookieName = cookieName;
    params.usageTime = usegeTime;
    params.usagePurpose = usagePurpose;
    params.siteName = siteName;
    params.cookieType = cookieTypes;
    params.ios = ios;
    params.android = android;
    params.status = selectedStatus;
    const isValid =
      cookieName &&
      cookieName?.trim().length > 0 &&
      siteName &&
      siteName?.trim().length > 0 &&
      usegeTime &&
      usegeTime?.trim().length > 0 &&
      usagePurpose &&
      usagePurpose?.trim().length > 0;

    if (!isValid) {
      Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
      return;
    }

    CookieManagementCommand.CreateCookie(params)
      .then((_res: any) => {
        Swal.fire(t("general.added"), " ", "success");
        onUpdate();
        onCloseMenu();
      })
      .catch((error: any) => {
        console.log("Hata :>> ", error);
      })
      .finally(() => {});
    //:Swal.fire(t('general.emptyFieldControlText'), " ", "error");
  };
  return (
    <Grid className={CKM.drawer}>
      <Grid container sx={{ paddingTop: "2rem" }} className={CKM.drawerHeader}>
        <Grid
          sx={{ paddingLeft: "3rem" }}
          size={{
            md: 6,
            xs: 6,
            lg: 11
          }}>
          <h1 className="headtxt">
            {selectedRow?.cookieName
              ? "Çerez Bilgisini Güncelle"
              : "Çerez Ekleme"}
          </h1>
        </Grid>

        <Grid
          size={{
            md: 1,
            xs: 1,
            lg: 1
          }}>
          <CloseIcon className={ckmCls("svg_icons", CKM.drawerClose)} onClick={onCloseMenu} />
        </Grid>
      </Grid>
      <Grid container sx={{ padding: "3rem" }} className={CKM.drawerBody}>
        <br />

        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <FormControl fullWidth className={CKM.fieldCookieType}>
            <InputLabel id="select-label">Çerez Tipi</InputLabel>
            <Select
              labelId="select-label"
              value={cookieTypes}
              onChange={handleSelectChangeCookieType}
              label="Çerez Tipi"
              className={ckmCls(CKM.input, CKM.inputSelect, CKM.fieldCookieType)}
            >
              {cookieType.map((item: any) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Çerez Adı"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={cookieName}
            className={ckmCls(CKM.input, CKM.inputTextfield, CKM.fieldCookieName)}
            onChange={handleChangeCookieName}
          />
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Kullanım Süresi"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={usegeTime}
            className={ckmCls(CKM.input, CKM.inputTextfield, CKM.fieldUsageTime)}
            onChange={handleChangeUsageTime}
          />
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Kullanım Amacı"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={usagePurpose}
            className={ckmCls(CKM.input, CKM.inputTextfield, CKM.fieldUsagePurpose)}
            onChange={handleChangeUsagePurpage}
            multiline
          />
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Site Adı"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={siteName}
            className={ckmCls(CKM.input, CKM.inputTextfield, CKM.fieldSiteName)}
            onChange={handleChangeSiteName}
          />
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <FormControl fullWidth className={CKM.fieldStatusSelect}>
            <InputLabel id="select-label">
              {t("customerInformation.isActive")}
            </InputLabel>
            <Select
              labelId="status-select-label"
              value={selectedStatus}
              onChange={handleSelectChangeIsActive}
              label={t("customerInformation.isActive")}
              className={ckmCls(CKM.input, CKM.inputSelect, CKM.fieldStatusSelect)}
            >
              {statusItems.map((item: any) => (
                <MenuItem key={item.value.toString()} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          container
          className={CKM.drawerPlatforms}
          sx={{ marginTop: "2rem" }}
          size={{
            xs: 6,
            sm: 6
          }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <FormControlLabel
              label={
                <div>
                  IOS
                  <AppleIcon />
                </div>
              }
              control={
                <Switch
                  checked={ios}
                  onChange={handleIosChange}
                  name="iosSwitch"
                  color="primary"
                  className={ckmCls(CKM.input, CKM.inputSwitch, CKM.fieldIosSwitch)}
                />
              }
            />
            <FormControlLabel
              label={
                <div>
                  Android <AndroidIcon />
                </div>
              }
              control={
                <Switch
                  checked={android}
                  onChange={handleAndroidChange}
                  name="androidSwitch"
                  color="primary"
                  className={ckmCls(CKM.input, CKM.inputSwitch, CKM.fieldAndroidSwitch)}
                />
              }
            />
          </Box>
        </Grid>

        <Grid
          container
          className={CKM.drawerActions}
          justifyContent={"flex-end"}
          sx={{ marginTop: "2rem" }}
          size={{
            xs: 6,
            sm: 6
          }}>
          {selectedRow?.cookieName ? (
            <SCUIButton
              text={"Güncelle"}
              type="primary"
              sizeType="fixed"
              size={"l"}
              className={ckmCls(CKM.input, CKM.inputButton, CKM.btnDrawerUpdate)}
              onClick={() => UpdateCookie()}
            ></SCUIButton>
          ) : (
            <SCUIButton
              text={"Kaydet"}
              type="primary"
              sizeType="fixed"
              size={"l"}
              className={ckmCls(CKM.input, CKM.inputButton, CKM.btnDrawerSave)}
              onClick={() => CreateCookie()}
            ></SCUIButton>
          )}
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 12
          }}>
          {selectedRow?.updateDate && (
            <b style={{ marginTop: "2rem" }}>
              Son Güncellenme Tarihi&nbsp;:&nbsp;{selectedRow.updateDate}
            </b>
          )}
        </Grid>

        <Grid
          size={{
            xs: 12,
            sm: 12
          }}>
          {" "}
          {selectedRow?.updateBy && (
            <b style={{ marginTop: "2rem" }}>
              Güncelleyen Kişi&nbsp;:&nbsp;{selectedRow.updateBy}
            </b>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
